module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAABKUlEQVQ4T6WSsS4EURiFv6OhUSm3EAlbiEqWEB6ATuEJJBqFbuMBNBqFQic6BQkPoKCSaESholEIQUElEZEcuXLJndnZmRG3Pt89//+fI/7xVJe1vQgsAEuSPgJXCdseA3aBCeBS0viPYSlsex44AvoiMCvprBK23QSuk7V2JC2naxY62+4F7oGBKH4BhiW91oFXgO1EmBm369i2g9sz0BNFx8CcJOeT6Rjb9iqwlQgbkh6KIs3AtsNVg2s/EJzakja7dSEPhwwvovhc0nRZifLwBrAG3AJNSZ+1YNvhQI/AEzAl6a2qur/OtmeAvZhnqWNHVLZPgENJab6l5t/Otluxw4NFeZZe2/YBcCVpvWrPTD1tjwKnQHB9/ys8BExK2rc9AtzU/ODuC6B2YvPs1C2JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/8.png
// module id = Z7vi
// module chunks = 1